
<div class="card">
    <div class="card-header" *ngIf="relatedMobiles" style="display: flex; align-items: center;">
        <h5 style="margin: 0; padding-right: 10px;" *ngIf="selectedContact" >{{selectedContact + ' : '}}</h5>
        <ejs-autocomplete id='mobileList' [allowCustom]="false" [dataSource]='relatedMobiles'
        name="mobileList" [fields]='{text:"Number", value:"Number"}'
        [showPopupButton]="true" (change)='onChange($event)'></ejs-autocomplete>
    </div>
        <div class="card-body"  *ngIf="selectedMobile">
        <ejs-grid [dataSource]='data' gridLines="None" [query]='query' [editSettings]="editSettings" 
                allowPaging='true' [pageSettings]='pageOptions' [height]="'50vh'"
            [columns]='columns' (actionBegin)='actionBegin($event)' (actionComplete)='actionComplete($event)'>
            <ng-template #editSettingsTemplate let-data>
                <div [formGroup]="formData">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <!-- <div class="position-relative"> -->
                            <textarea type="text" class="form-control chat-input" placeholder="Enter Message..."
                                formControlName="Comment" [ngClass]="{'is-invalid': submitClicked && f.Comment.errors}"></textarea>
                            <div *ngIf="submitClicked && f.Commenterrors" class="invalid-feedback">
                                <span *ngIf="f.Comment.errors.required">This value is required.</span>
                            </div>
                        <!-- </div> -->
                    </div>
                </div>
            </ng-template>
        </ejs-grid>
    </div>
</div>

<ng-template #navTemplate let-data>
    <div class="message-container"
         [ngClass]="{'sent-message': data.MessageType == 'sent', 'received-message': data.MessageType != 'sent'}">
        <div class="message-bubble">
            <div class="message-header">
                <strong>{{ data.UserName }}</strong>
            </div>
            <div class="message-content">
                @if (data.Type?.startsWith('image')){
                    <a [href]="'https://images.mytinyerp.com/WhatsApp/files/' + data.Id + data.Type.split('_')[1]"
                    target="_blank">
                        <img [src]="'https://images.mytinyerp.com/WhatsApp/files/' + data.Id + data.Type.split('_')[1]"
                            [alt]="'Image'"
                            width="100"
                            class="rounded" />
                    </a>
                }@else if (data.Type?.startsWith('audio')) {
                    <div>
                        <audio controls>
                            <source [src]="'https://images.mytinyerp.com/WhatsApp/files/' + data.Id + data.Type.split('_')[1]"
                                    [type]="'audio/ogg; codecs=opus'" />
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                }@else if(data.Type?.startsWith('document')){
                    <p>{{data.Type.split('_')[1]}}</p>
                    <a [href]="'https://images.mytinyerp.com/WhatsApp/files/' + data.Id + '_' + data.Type.split('_')[1]"
                        download
                        title="Download File">
                            <i class="bx bx-download bx-lg"></i>
                    </a>
                } @else {
                    <p>{{ data.Message }}</p>
                }
            </div>
            <div class="message-status">
                <div *ngIf="data.MessageType === 'sent'" class="status-details">
                    <span class="status-label" [ngClass]="{'delivered': data.DeliveredDateTime, 'read': data.ReadDateTime}">
                        {{ data.ReadDateTime ? 'Read' : (data.DeliveredDateTime ? 'Delivered' : 'Sent') }}
                    </span>
                    <span class="status-time">
                        <app-get-date-time [dateTime]="data.ReadDateTime || data.DeliveredDateTime || data.SentDateTime"></app-get-date-time>
                    </span>
                </div>
                <div *ngIf="data.MessageType !== 'sent'" class="received-time">
                    <i class="bx bx-time-five align-middle me-1"></i>
                    <app-get-date-time [dateTime]="data.Date"></app-get-date-time>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<div *ngIf="selectedMobile">
    <app-message-input [mobileNo]="selectedMobile"></app-message-input>
</div>
